
import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { UserInfos } from "../../../shared/ui/username-icon/user-infos.type";
import { UsernameIconComponent } from "../../../shared/ui/username-icon/username-icon.component";
import { UserService } from "@teammood/shared/util/user";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";
import { FeedbackHookRequest } from "../user-request.types";

@Component({
    selector: 'user-feedback-hook',
    templateUrl: './user-feedback-hook.component.html',
    styleUrls: ['./user-feedback-hook.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    TranslateModule,
    UsernameIconComponent,
    MatTooltipModule
]
})
export class UserFeedbackHookComponent implements OnInit {

    @Input()
    feedbackHookRequest: FeedbackHookRequest;

    userInfos: UserInfos;

    @Output() createQuestion: EventEmitter<void> = new EventEmitter();
    @Output() createIssue: EventEmitter<void> = new EventEmitter();
    @Output() createKudos: EventEmitter<void> = new EventEmitter();
    @Output() createPoll: EventEmitter<void> = new EventEmitter();
    
    constructor(
        private userService: UserService
    ){}

    ngOnInit(): void {
        this.userService.get().then(async (user) => {
            if (user) {
                this.userInfos = new UserInfos(user.firstname, user.lastname);
            }
        });
    }

    question() {
        this.createQuestion.emit();
    }

    issue() {
        this.createIssue.emit();
    }

    praise() {
        this.createKudos.emit();
    }
    
    poll() {
        this.createPoll.emit();
    }

}